import * as ExcelJS from 'exceljs';
import { Fill, FillPattern, Style } from 'exceljs';
import { Writable } from 'stream';
import { XlsxWriter } from '../interfaces/xlsx-writer.interface';

export class XlsxStreamWriter implements XlsxWriter {
    workbook: ExcelJS.stream.xlsx.WorkbookWriter;
    worksheet: ExcelJS.Worksheet;

    constructor(private readonly stream: Writable) {
        this.workbook = new ExcelJS.stream.xlsx.WorkbookWriter({
            stream: this.stream,
            useStyles: true,
            useSharedStrings: true,
        });

        this.worksheet = this.workbook.addWorksheet('Report');
    }

    writeColumns(
        columns: { header: string; key: string; width: number }[],
        setStyles?: (row: ExcelJS.Row, defaultCellStyle: Partial<Style>, defaultCellFill: Fill) => void,
    ): void {
        const row = this.worksheet.addRow(columns.map((column) => column.header));
        const defaultCellStyle = {
            font: {
                bold: true,
                color: { argb: 'FFFFFF' },
            },
            alignment: { horizontal: 'center' },
        } as Partial<Style>;
        const defaultCellFill: FillPattern = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '134EF7' },
        };
        if (setStyles) {
            setStyles(row, defaultCellStyle, defaultCellFill);
        } else {
            row.eachCell(function (cell) {
                cell.style = defaultCellStyle;
                cell.fill = defaultCellFill;
            });
        }
        this.worksheet.columns.forEach((column, i) => {
            column.width = columns[i].width;
        });
        row.commit();
    }

    writeRow(row: unknown[], cb?: (row: ExcelJS.Row) => void): void {
        const addedRow = this.worksheet.addRow(row);
        if (cb) cb(addedRow);
        addedRow.commit();
    }

    async close(): Promise<string | void> {
        await this.workbook.commit();
    }
}
